export function BytesToSize(bytes) {
	var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
	if (bytes === 0) return '0 Byte';
	var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
	return NumberWithSeparators(Math.round(bytes / Math.pow(1024, i), 2)) + ' ' + sizes[i];
}

export function NumberWithSeparators(number) {
	return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}